import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { APIConfig, CustomerApiService, CustomerCommercial } from 'src/app/api';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { PerfilService } from '../ajs-perfil.service';
import { CacheableGet } from './cacheable-get';
import { FIVE_MINUTES_IN_MILLIS, PROFILE_CACHE_TIME } from './consts';

@Injectable({
  providedIn: 'root'
})
export class ProfileIntegrationService {

  private getRequest: CacheableGet<CustomerCommercial>;

  private get currentUserId() {
    const user = this.perfilService.getCacheUserData();

    return user && user.id || 0;
  }

  public get shouldUpdate() {
    return this.getRequest.shouldUpdate;
  }

  constructor(
    private http: HttpClient,
    private apiConfig: APIConfig,
    private customerApiService: CustomerApiService,
    private perfilService: PerfilService,
    @Optional() @Inject(PROFILE_CACHE_TIME) cacheTime: number,
  ) {
    if (!cacheTime) {
      cacheTime = FIVE_MINUTES_IN_MILLIS;
    }

    this.getRequest = new CacheableGet<CustomerCommercial>(
      cacheTime,
      () => this.customerApiService.getCustomerCommercialData(this.currentUserId),
    );
  }

  /**
   * Obtém os dados de integração para o cliente atual
   */
  public getIntegrationData(): Observable<string> {
    return this.getRequest.get().pipe(
      map(commercialData => commercialData ? commercialData.integracao : null),
    );
  }

  /**
   * Define a integração para o usuário
   *
   * @param provider Slug da integração
   */
  public setIntegrationData(provider: string): Observable<void> {
    return this.getRequest.get().pipe(
      switchMap(commercialData =>
        this.http.post<void>(`${this.apiConfig.customerApiUrl}/clientes/${this.currentUserId}/comercial`, {
          ...commercialData,
          integracao: provider,
        })),
      tap(() => this.getRequest.markForUpdate()),
    );
  }
}
